export default __webpack_public_path__ + "static/media/crossmint-image.9e6c733e.png";